import Button from '@components/Button/Button';
import FormInput from '@components/Form/Input/FormInput';
import { Body2, Subtitle2 } from '@components/Texts/Texts';
import tw, { css, styled, theme } from 'twin.macro';

export const NotifyMeContainer = styled.div<{ center: boolean }>`
  ${tw`flex flex-col`};
  ${props => (props.center ? tw`items-center justify-center` : undefined)}
`;

export const NotifyMeNotifiedInfo = styled.div`
  background: #242429;
  ${tw`flex items-center p-2 rounded-lg m-3`}
`;

export const NotifyMeNotifiedInfoText = styled(Subtitle2)`
  ${tw`text-light-high ms-1`}
`;

export const NotifyMeDivider = styled.div`
  ${tw`w-full`};
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const NotifyMeFooterText = styled(Body2)`
  ${tw`flex flex-row justify-center items-center text-center pb-1 text-light-low m-2`};
`;

export const NotifyMeLoggedInFormWrapper = styled.div`
  ${tw`flex sm:flex-col p-3`}
`;

export const NotifyMeLoggedInButton = styled(Button)``;

export const NotifyMeLoggedOutLabel = styled(Subtitle2)`
  ${tw`px-3 pt-3`}
`;

export const NotifyMeLoggedOutFormWrapper = styled.form`
  ${tw`flex sm:flex-col flex-row w-full p-3`}
`;

export const NotifyMeLoggedOutInputWrapper = styled.div`
  ${tw`flex-1 h-full`}
`;

export const NotifyMeLoggedOutInput = styled(FormInput)`
  ${tw`h-6`};
`;

export const NotifyMeLoggedOutButton = styled(Button)`
  ${tw`px-0 ms-1 h-5 sm:ms-0 sm:mt-1`};
  ${css`
    @media (min-width: ${theme`screens.md.min`}) {
      max-width: 120px;
    }
  `}
`;
